import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { TankService } from 'src/app/services/tank.service';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  currentUser: User;

  constructor(private tankService: TankService, private userService: UserService, private router: Router) { }

  ngOnInit(): void {

    this.currentUser = this.userService.getCurrentUser();
  
    if (this.currentUser.role == "operador") {
      this.router.navigateByUrl("/new-discharge");
    } 
    else if (this.currentUser.role == "admin") {
      this.router.navigateByUrl("/discharges");
    }
    
  }


}
